import { ReduxDIContainer } from 'redux-di-container';

import MailingService from './Mailing.service';

const di = new ReduxDIContainer();
di.registerServices([
  { key: 'mailingService', class: MailingService },
]);

const mailingService = di.getService('mailingService');

export {
  di,
  mailingService,
};
